export const healthQuotes = [
  "Îmbunătățește sănătatea inimii prin stimularea circulației sangvine.",
  "Ajută la scăderea tensiunii arteriale la persoanele cu hipertensiune.",
  "Reduce nivelul de colesterol „rău” (LDL) din sânge.",
  "Crește nivelul colesterolului „bun” (HDL).",
  "Scade riscul de infarct miocardic.",
  "Diminuează riscul de accident vascular cerebral.",
  "Îmbunătățește elasticitatea vaselor de sânge.",
  "Ajută la reglarea ritmului cardiac în condiții de efort moderat.",
  "Contribuie la menținerea unei greutăți corporale sănătoase.",
  "Sprijină arderea caloriilor într-un mod blând, dar constant.",
  "Reduce grăsimea viscerală (grăsimea din jurul organelor).",
  "Îmbunătățește sensibilitatea la insulină și scade riscul de diabet de tip 2.",
  "Ajută la controlul glicemiei la persoanele care au deja diabet.",
  "Stimulează metabolismul bazal pe termen lung.",
  "Întărește musculatura picioarelor (gambe, coapse, fesieri).",
  "Îmbunătățește tonusul muscular general al corpului.",
  "Crește rezistența fizică și capacitatea de efort.",
  "Menține articulațiile mobile și funcționale.",
  "Poate reduce rigiditatea articulară, mai ales dimineața.",
  "Ajută la ameliorarea durerilor ușoare de spate prin mișcare controlată.",
  "Îmbunătățește postura corporală.",
  "Contribuie la alinierea corectă a coloanei vertebrale.",
  "Reduce riscul de osteoporoză prin încărcarea blândă a oaselor.",
  "Poate crește densitatea minerală osoasă în timp.",
  "Diminuează riscul de căderi la vârstnici prin îmbunătățirea echilibrului.",
  "Îmbunătățește coordonarea și controlul mișcărilor.",
  "Ajută la menținerea flexibilității tendoanelor și ligamentelor.",
  "Favorizează producția de endorfine, „hormonii fericirii”.",
  "Reduce nivelul de stres acumulat pe parcursul zilei.",
  "Ajută la diminuarea simptomelor ușoare de anxietate.",
  "Poate susține ameliorarea simptomelor ușoare de depresie.",
  "Oferă o pauză mentală de la griji și gânduri intrusive.",
  "Crește claritatea mentală și capacitatea de concentrare.",
  "Stimulează creativitatea și gândirea laterală.",
  "Poate îmbunătăți memoria pe termen scurt și lung.",
  "Ajută la un somn mai profund și odihnitor.",
  "Poate reduce dificultățile de adormire (insomnie ușoară).",
  "Reglează ritmul circadian dacă este făcut în aer liber, la lumină naturală.",
  "Contribuie la echilibrarea nivelului de energie pe parcursul zilei.",
  "Reduce senzația de oboseală psihică după ore lungi de stat pe scaun.",
  "Ajută la ruperea perioadelor lungi de sedentarism.",
  "Scade riscul de afecțiuni asociate statului prelungit (sindrom metabolic).",
  "Sprijină buna funcționare a sistemului imunitar.",
  "Poate reduce inflamația cronică de grad mic din organism.",
  "Îmbunătățește funcția plămânilor și capacitatea respiratorie.",
  "Poate reduce simptomele ușoare ale astmului de efort (sub supraveghere medicală).",
  "Ajută digestia prin stimularea peristaltismului intestinal.",
  "Poate ameliora constipația prin mișcare regulată.",
  "Contribuie la un apetit mai echilibrat (nici prea mare, nici prea mic).",
  "Poate ajuta la reglarea hormonilor foamei și sațietății.",
  "Favorizează o mai bună hidratare, pentru că ne amintește să bem apă.",
  "Poate reduce pofta de dulciuri sau gustări nesănătoase după masă.",
  "Ajută la controlul greutății după ce ai slăbit, prevenind efectul „yo-yo”.",
  "Contribuie la reducerea riscului de anumite tipuri de cancer (ex. colon).",
  "Scade riscul de boală coronariană.",
  "Poate crește speranța de viață dacă este practicat constant.",
  "Încetinește unele procese de îmbătrânire biologică.",
  "Ajută la menținerea funcțiilor cognitive la vârsta a treia.",
  "Poate reduce riscul de demență și boala Alzheimer.",
  "Susține sănătatea psihică în perioadele de tranziție (pensionare, schimbări majore).",
  "Crește încrederea în sine prin realizarea unor obiective mici, zilnice.",
  "Oferă un sentiment de control asupra propriei sănătăți.",
  "Poate îmbunătăți imaginea de sine și relația cu propriul corp.",
  "Este o formă de mișcare ușor accesibilă aproape oricui.",
  "Nu necesită echipament scump sau abonament la sală.",
  "Poate fi făcut aproape oriunde: pe stradă, în parc, la țară.",
  "Este o activitate cu impact redus asupra articulațiilor (comparativ cu alergarea).",
  "Potrivit pentru începători sau persoane cu afecțiuni care nu permit efort intens.",
  "Permite ajustarea ușoară a intensității (viteză, durată, pantă).",
  "Poate fi integrat ușor în rutina zilnică (mers la serviciu, la magazin etc.).",
  "Reduce dependența de mașină pentru distanțe scurte.",
  "Contribuie indirect la un mediu mai curat prin reducerea poluării.",
  "Oferă ocazia de a petrece timp în natură, ceea ce calmează sistemul nervos.",
  "Expunerea la lumină naturală ajută la producția de vitamina D (dacă e soare).",
  "Mersul în zone verzi reduce suplimentar stresul și tensiunea psihică.",
  "Poate deveni un ritual de relaxare după o zi încărcată.",
  "Încurajează respirația profundă și conștientă în timpul mișcării.",
  "Poate fi combinat cu practici de mindfulness (atenție la pași, respirație, mediul înconjurător).",
  "Creează spațiu pentru reflecție și auto-analiză.",
  "Poate fi un timp de calitate petrecut cu familia sau prietenii.",
  "Îmbunătățește relațiile sociale când mergi împreună cu alții.",
  "Poate reduce singurătatea dacă participi la grupuri de mers.",
  "Încurajează discuții relaxate, fără presiune, în timp ce te miști.",
  "Poate servi ca pauză activă în timpul programului de lucru.",
  "Crește productivitatea când revii la birou după o plimbare scurtă.",
  "Reduce durerea de ochi și tensiunea cauzată de statul mult în fața ecranelor.",
  "Ajută la ruperea dependenței de telefon sau calculator pentru câteva momente.",
  "Îmbunătățește orientarea în spațiu și harta mentală a locurilor pe care le vizitezi.",
  "Te ajută să descoperi locuri noi în cartierul sau orașul tău.",
  "Crește sentimentul de apartenență la comunitate.",
  "Poate fi practicat în siguranță de majoritatea oamenilor, cu un risc redus de accidentare.",
  "Este ușor de reluat după o pauză, fără pregătiri speciale.",
  "Poate fi combinat cu alte activități plăcute: ascultat muzică, podcast, audiobooks.",
  "Poate deveni o rutină de cuplu sau de familie care consolidează legăturile.",
  "Contribuie la autocontrol, pentru că presupune consecvență și disciplină.",
  "Oferă ocazia de a observa natura, anotimpurile și schimbările din jur, ceea ce îmbunătățește starea de spirit.",
  "Poate reduce pofta de fumat sau alte obiceiuri nocive, oferind o alternativă sănătoasă în momentele de stres.",
  "Îmbunătățește modul în care corpul folosește oxigenul, crescând eficiența sistemelor interne.",
  "Este o formă de mișcare care poate fi menținută toată viața, indiferent de vârstă.",
  "Mersul pe jos, făcut regulat, combină beneficii fizice, mentale și emoționale, contribuind global la o viață mai lungă, mai sănătoasă și mai echilibrată."
];